import React, { Component } from "react";

export default class NoteList extends Component {
  render() {
    return (
      <div className="note-list">
        {this.props.notes &&
          this.props.notes.length > 0 &&
          this.props.notes.map((n) => (
            <div className="quote-note">
              <div className="quote-note-header">
                <div className="quote-note-author">{n.Author}</div>
                <div className="quote-note-date">
                  {n.Date.toLocaleDateString(undefined, {
                    month: "2-digit",
                    day: "2-digit",
                    year: "numeric",
                  })}
                </div>
              </div>
              <div className="quote-note-text">{n.Note}</div>
            </div>
          ))}
      </div>
    );
  }
}
